import React, { useState } from "react";
import {
  beforeUpload,
  UploadButton,
  uploadImages,
} from "../../lib/global_functions";
import { AVATAR_CREATE } from "../../lib/config";
import { useSelector } from "react-redux";
import { Button, Card, Col, Row, Upload } from "antd";
import { CreateDataOnServer } from "../../lib/api";
import toast from "react-hot-toast";

export default function AvatarModal({
  closeModal,
  loading,
  setLoading,
  getDataList,
}) {
  const { access_token, csrf_token, ui_size } = useSelector(
    (state) => state.user
  );
  const [imageUrl, setImageUrl] = useState("");
  async function uploadHandler() {
    if (imageUrl !== "") {
      setLoading(true);
      await CreateDataOnServer(
        AVATAR_CREATE,
        { url: imageUrl },
        access_token,
        csrf_token
      )
        .then(() => {
          setLoading(false);
          closeModal(true);
          toast.success("Uploaded avatar successfully");
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error?.response?.data?.error || "Connection Error");
        });
    }

    setImageUrl("");
    getDataList();
  }

  return (
    <Row gutter={[24, 24]} justify={"center"}>
      <Col>
        <Upload
          name="avatar_img"
          accept=".jpg,.jpeg,.png"
          listType="picture-card"
          showUploadList={false}
          style={{ height: "200px", width: "200px" }}
          customRequest={(option) =>
            uploadImages({
              ...option,
              access_token,
              csrf_token,
              folder_name: "AVATARS",
              image: imageUrl,
              setImage: setImageUrl,
            })
          }
          beforeUplload={(file) => beforeUpload(file, 1)}
          isImageUrl={true}
        >
          {imageUrl !== "" ? (
            <Card
              styles={{
                body: {
                  width: "200px",
                  height: "200px",
                  padding: "0px",
                },
              }}
            >
              <img
                style={{ height: "200px", width: "200px" }}
                src={imageUrl}
                alt="thumbnail"
              />
            </Card>
          ) : (
            UploadButton(loading)
          )}
        </Upload>
      </Col>
      <Col span={24}>
        <Row justify={"end"}>
          <Col>
            <Button
              size={ui_size}
              disabled={imageUrl === ""}
              type="primary"
              loading={loading}
              onClick={() => uploadHandler()}
            >
              Upload
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
